import { UI_COLORS } from "../../../config";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faArrowRightToBracket,
  faArrowRightFromBracket,
} from "@fortawesome/free-solid-svg-icons";
import React from "react";

export const getButtonStyle = (isFromHeader) => ({
  backgroundColor: isFromHeader ? "transparent" : UI_COLORS.primary,
  color: UI_COLORS.white,
  padding: isFromHeader ? "0" : "8px 16px 8px 8px",
  borderRadius: isFromHeader ? "0" : "4px",
  border: "none",
  cursor: "pointer",
  fontWeight: "bold",
  transition: "all 0.3s",
});

export const getButtonIcon = (isFromHeader, isAuthenticated) => {
  return isFromHeader ? (
    <FontAwesomeIcon
      icon={isAuthenticated ? faArrowRightFromBracket : faArrowRightToBracket}
      size="2xl"
    />
  ) : (
    <img src="/msal-logo.png" alt="MSAL Logo" className="h-8" />
  );
};

export const handleHover = (e, isFromHeader, isEntering) => {
  const target = e.currentTarget;

  if (isFromHeader) {
    target.style.color = isEntering ? UI_COLORS.primary : UI_COLORS.white;
  } else {
    target.style.backgroundColor = isEntering
      ? UI_COLORS.primaryDark
      : UI_COLORS.primary;
  }
};
